/**
 * Web Speech API(SpeechSynthesis) 얇은 래퍼. 웹 특성상 이 탭이 화면에 켜져 있을 때만
 * 재생되고, 백그라운드/앱종료 상태에서는 소리가 안 남(텍스트/푸시 알림은 그와 무관하게 항상 감).
 * 브라우저가 지원 안 하면 조용히 무시 — 음성은 어디까지나 보조 수단이라 실패해도 기능엔 영향 없음.
 */

const LANG_TAG = {
  ko: 'ko-KR',
  en: 'en-US',
  vi: 'vi-VN',
  ru: 'ru-RU',
};

export function isVoiceSupported() {
  return typeof window !== 'undefined' && !!window.speechSynthesis;
}

/**
 * @param {string} text
 * @param {{ lang?: 'ko'|'en'|'vi'|'ru' }} [opts]
 */
export function speak(text, { lang = 'ko' } = {}) {
  if (!isVoiceSupported() || !text) return;
  try {
    // 알림이 짧은 간격으로 여러 개 오면 겹쳐 읽히는 걸 막기 위해 이전 발화를 취소하고 새로 재생
    window.speechSynthesis.cancel();
    const utter = new window.SpeechSynthesisUtterance(text);
    utter.lang = LANG_TAG[lang] || LANG_TAG.ko;
    utter.rate = 1;
    window.speechSynthesis.speak(utter);
  } catch {
    // 음성 재생 실패는 무시
  }
}
